const SET_NEOFINTECH_PHASE_1_RESET = state => {
  state.neofintech.phase1 = {
    countries: [],
    companyLocations: [],
    requesterCompanyTypes: [],
    businessSectors: [],
    fundraisingProgramTypes: [],
    programBeneficiaries: [],
    status: null 
  }
}

const SET_NEOFINTECH_PHASE_2_RESET = state => {
  state.neofintech.phase2 = {
    programCurrencyTypes: [],
    requestedAmountRanges: [],
    sellsAmountRanges: [],
    ebidtaSign: [],
    ebidtaAmountRanges: [],
    sellsForecast: [],
    hasAccountAuditor: [],
    status: null
  }
}

const SET_NEOFINTECH_CODE = (state, payload) => {
  state.neofintech.code = payload
}

const SET_NEOFINTECH_PHASE_1 = (state, payload) => {
  state.neofintech.phase1 = payload
}

const SET_NEOFINTECH_PHASE_2 = (state, payload) => {
  state.neofintech.phase2 = payload
}

const SET_NEOFINTECH_CHOSEN_LOCATION = (state, payload) => {
  state.neofintech.chosenLocation = payload
}

const SET_NEOFINTECH_GENERAL = (state, payload) => {
  state.neofintech.email = payload.email
  state.neofintech.candidates = payload.candidates
  state.neofintech.status = payload.status
  state.neofintech.requestId = payload.GSI1SK
  state.neofintech.createdAt = payload.createdAt
  state.neofintech.updatedAt = payload.updatedAt
  state.neofintech.userData = {
    userId: payload.user_data.user_id,
    firstName: payload.user_data.first_name,
    lastName: payload.user_data.last_name,
    jobPosition: payload.user_data.job_position,
    companyName: payload.user_data.company_name,
    jobCity: payload.user_data.city,
    jobCountry: payload.user_data.country,
    contactPhone: payload.user_data.contact_phone,
    email: payload.user_data.email
  }
  state.neofintech.phase = payload.phase
  state.neofintech.ccRecipients = payload.cc_recipients
  state.neofintech.contactMethod = payload.contact_method
}

const SET_NEOFINTECH_USER_DATA = (state, payload) => {
  state.neofintech.userData = {
    userId: payload.user_data.user_id,
    firstName: payload.user_data.first_name,
    lastName: payload.user_data.last_name,
    jobPosition: payload.user_data.job_position,
    companyName: payload.user_data.company_name,
    jobCity: payload.user_data.city,
    jobCountry: payload.user_data.country,
    contactPhone: payload.user_data.contact_phone,
    email: payload.user_data.email
  }
}

const SET_NEOFINTECH_COUNTRIES = (state, payload) => {
  state.neofintech.phase1.countries = payload
}

const SET_NEOFINTECH_COMPANY_LOCATIONS = (state, payload) => {
  state.neofintech.phase1.companyLocations = payload
}

const SET_NEOFINTECH_REQUESTER_COMPANY_TYPES = (state, payload) => {
  state.neofintech.phase1.requesterCompanyTypes = payload
}

const SET_NEOFINTECH_ECONOMIC_SECTORS = (state, payload) => {
  state.neofintech.phase1.economicSectors = payload
}

const SET_NEOFINTECH_BUSINESS_SECTORS = (state, payload) => {
  state.neofintech.phase1.businessSectors = payload
}

const SET_NEOFINTECH_CAPITAL_PROGRAM_TYPES = (state, payload) => {
  state.neofintech.phase1.capitalProgramTypes = payload
}

const SET_NEOFINTECH_FUNDRAISING_PROGRAM_TYPES = (state, payload) => {
  state.neofintech.phase1.fundraisingProgramTypes = payload
  state.neofintech.phase1.programBeneficiaries = []
}

const SET_NEOFINTECH_PROGRAM_BENEFICIARIES = (state, payload) => {
  state.neofintech.phase1.programBeneficiaries = payload
  state.neofintech.phase1.fundraisingProgramTypes = []
}

const SET_NEOFINTECH_PROGRAM_CURRENCY_TYPES = (state, payload) => {
  state.neofintech.phase2.programCurrencyTypes = payload
}

const SET_NEOFINTECH_REQUESTED_AMOUNT_RANGES = (state, payload) => {
  state.neofintech.phase2.requestedAmountRanges = payload
}

const SET_NEOFINTECH_SELLS_AMOUNT_RANGES = (state, payload) => {
  state.neofintech.phase2.sellsAmountRanges = payload
}

const SET_NEOFINTECH_EBIDTA_SIGN = (state, payload) => {
  state.neofintech.phase2.ebidtaSign = payload
}

const SET_NEOFINTECH_EBIDTA_AMOUNT_RANGES = (state, payload) => {
  state.neofintech.phase2.ebidtaAmountRanges = payload
}

const SET_NEOFINTECH_SELLS_FORECAST = (state, payload) => {
  state.neofintech.phase2.sellsForecast = payload
}

const SET_NEOFINTECH_HAS_ACCOUNT_AUDITOR = (state, payload) => {
  state.neofintech.phase2.hasAccountAuditor = payload
}

const SET_NEOFINTECH_ONBOARD_RESQUEST = (state, payload) => {
  state.neofintech = payload
}

const SET_ADMIN_ONBOARD_RESQUESTS = (state, payload) => {
  state.admin.onboardRequests = payload
}

export default {
  SET_NEOFINTECH_GENERAL,
  SET_NEOFINTECH_CODE,
  SET_NEOFINTECH_PHASE_1,
  SET_NEOFINTECH_PHASE_1_RESET,
  SET_NEOFINTECH_COUNTRIES,
  SET_NEOFINTECH_COMPANY_LOCATIONS,
  SET_NEOFINTECH_CHOSEN_LOCATION,
  SET_NEOFINTECH_REQUESTER_COMPANY_TYPES,
  SET_NEOFINTECH_USER_DATA,
  SET_NEOFINTECH_ECONOMIC_SECTORS,
  SET_NEOFINTECH_BUSINESS_SECTORS,
  SET_NEOFINTECH_CAPITAL_PROGRAM_TYPES,
  SET_NEOFINTECH_FUNDRAISING_PROGRAM_TYPES,
  SET_NEOFINTECH_PROGRAM_CURRENCY_TYPES,
  SET_NEOFINTECH_REQUESTED_AMOUNT_RANGES,
  SET_NEOFINTECH_EBIDTA_SIGN,
  SET_NEOFINTECH_SELLS_AMOUNT_RANGES,
  SET_NEOFINTECH_EBIDTA_AMOUNT_RANGES,
  SET_NEOFINTECH_SELLS_FORECAST,
  SET_NEOFINTECH_HAS_ACCOUNT_AUDITOR,
  SET_ADMIN_ONBOARD_RESQUESTS,
  SET_NEOFINTECH_ONBOARD_RESQUEST,
  SET_NEOFINTECH_PHASE_2,
  SET_NEOFINTECH_PHASE_2_RESET,
  SET_NEOFINTECH_PROGRAM_BENEFICIARIES
}
